import { getDataSource, getMe, getInventory } from '../../store/appReducer'
import { checkInventoryFeatureEnabled } from '../../../configs'
import { ROUTES, DATASOURCES } from '../../constants'
import history from '../../containers/History'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'Inventory.'
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`

// ------------------------------------
// Actions
// ------------------------------------
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})

export const getInventoryData = (forceUpdate = false) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  if (!checkInventoryFeatureEnabled(meDataSource)) return history.push(ROUTES.DASHBOARD)

  dispatch(dataRequest())

  const promises = meDataSource.data && !forceUpdate ? Promise.resolve() : dispatch(getMe())

  return promises
    .then(() => {
      const apiCalls = []
      const me = getDataSource(getState(), DATASOURCES.ME)
      const inventory = getDataSource(getState(), DATASOURCES.INVENTORY)

      const [ team ] = me.data.teams

      apiCalls.push(dispatch(getInventory(team.id)))

      return Promise.all(apiCalls)
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getInventory', err)
      dispatch(dataFailure())
    })
}

/* export const handleOnNavClick = (resetFiltersAndSorts = true, handleRouting = false) => (dispatch, getState) => {
  let promises = Promise.resolve()
  if (handleRouting) {
    promises = promises.then(() => history.push(ROUTES.DASHBOARD))
  }

  return promises
} */

const initialState = {
  dataIsFetching: false,
  dataLastUpdated: null,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function dashboardReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/Inventory/module.js